<template>
  <div class="poster" v-if="painting">
    <vue-canvas-poster :widthPixels="750" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
  </div>
</template>

<script>
// 竖版 750 * 1060
// https://sunniejs.github.io/vue-canvas-poster/
import { mapGetters } from 'vuex'
import { Icon } from 'vant'
import { VueCanvasPoster } from 'vue-canvas-poster'
import stamp from '@/assets/images/stamp.png'

const textCss = (top, left, fontSize, color) => {
  return [
    {
      top: `${top}px`,
      left: `${left}px`,
      fontSize: `${fontSize}px`,
      color
    }
  ]
}

export default {
  name: 'home',
  components: {
    [Icon.name]: Icon,
    VueCanvasPoster
  },
  props: {
    posterData: {
      type: Object
    }
  },
  data () {
    return {
      painting: null
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
    this.render()
  },
  methods: {
    render () {
      this.painting = {
        width: '750px',
        height: '1060px',
        background: this.posterData.bg_img,
        views: [
          this.renderClazzName(this.posterData.clazz_name),
          {
            type: 'text',
            text: `${this.posterData.time_range}`,
            css: [
              {
                top: '328px',
                left: '268px',
                fontSize: '27px',
                color: '#000'
              }
            ]
          },
          {
            type: 'text',
            text: `${this.userprofile.uuid}`,
            css: [
              {
                top: '372px',
                left: '155px',
                fontSize: '30px',
                color: '#000'
              }
            ]
          },
          {
            type: 'text',
            text: `${this.posterData.clazz_distance}公里`,
            css: [
              {
                top: '372px',
                left: '460px',
                fontSize: '30px',
                color: '#000'
              }
            ]
          },
          ...this.renderData(),
          {
            type: 'text',
            text: `${this.posterData.creator}`,
            css: [
              {
                bottom: '237px',
                left: '460px',
                width: '220px',
                fontSize: '28px',
                maxLines: 1,
                color: '#000'
              }
            ]
          },
          {
            type: 'image',
            url: stamp,
            css: {
              bottom: `148px`,
              right: `180px`,
              width: '155px',
              height: '155px'
            }
          }
        ]
      }
    },
    renderClazzName (clazzName) {
      const maxWidth = 600
      const fontSize = '36px'
      const charLength = 36
      const numLength = 18
      let width = 0
      for (let i = 0; i < clazzName.length; i++) {
        if (isNaN(parseInt(clazzName[i]))) {
          width += charLength
        } else {
          width += numLength
        }
      }
      console.log(width)

      width = width > maxWidth ? maxWidth : width
      const left = (750 - width) / 2

      return {
        type: 'text',
        text: clazzName,
        css: [
          {
            top: '240px',
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxLines: 1,
            fontSize,
            fontWeight: '900',
            color: '#333'
          }
        ]
      }
    },
    renderData (top, left) {
      const fontSize = 24
      const color = '#000'
      top = 505
      left = 230
      return [
        {
          type: 'text', // 昵称
          text: this.userprofile.nickname,
          css: [
            {
              top: `${top}px`,
              left: `${left}px`,
              width: '150px',
              fontSize: `${fontSize}px`,
              maxLines: 1,
              color
            }
          ]
        },
        {
          type: 'text',
          text: this.posterData.days + '',
          css: textCss(top - 5, left + 300, 32, color)
        },
        {
          type: 'text',
          text: this.posterData.rank + '',
          css: textCss(top + 85, left + 55, 32, color)
        },
        {
          type: 'text',
          text: this.posterData.distance + '',
          css: textCss(top + 90, left + 296, 32, color)
        },
        {
          type: 'text',
          text: this.posterData.pace + '',
          css: textCss(top + 180, left + 25, 32, color)
        },
        {
          type: 'text',
          text: this.posterData.duration + '',
          css: textCss(top + 190, left + 296, 32, color)
        }
      ]
    },
    success (src) {
      this.$emit('success', src)
    },
    fail (err) {
      this.$emit('fail', err)
    }
  }
}
</script>
